export default __webpack_public_path__ + "logo-insegnia-Italia-81e4dfba9be674584d0062e572c6f674.svg";